// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3y--4","label":"SetPasswdForm_label__17JKg"};